export const requestHandler = {
    setRequestTimer 
};


const setRequestTimer = (time, action) => {
    setTimeout(() => action(), time)
}